<template>
  <div class="integralUser seller-style">
    <h2 class="f18 fb normal gray_2">积分管理-用户积分</h2>
    <div class="box30"></div>
    <div>
      <div class="flex align_center">
        <div class="lable">客户：</div>
        <el-input class="w240 mar20_r" placeholder="请输入客户名称或联系电话" v-model.trim="selVal"></el-input>
        <el-button type="primary" @click="getPointsDtl">查询</el-button>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="name" label="客户名称" min-width="15%" />
        <el-table-column show-overflow-tooltip prop="phone" label="联系电话" min-width="15%" />
        <el-table-column prop="grantPoints" label="积分总数" min-width="15%" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div class="blue" @click="toRecordDetail(scope.row)">查看详情</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      selVal: "",
      value: "",
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.formatDate();
    this.getPointsDtl();
  },
  methods: {
    getPointsDtl() {
      const params = {
        selVal: this.selVal,
        useTimeEnd: this.value ? this.value[1] : "",
      };
      this.$store.dispatch("points/points/getPointsByShopId", params).then((data) => {
        console.log(data);
        this.list = data;
      });
    },
    toRecordDetail(record) {
      this.$router.push({
        path: "/mj/integral/userDetail",
        query: {
          boId: record.boIdStr,
        },
      });
    },
    formatDate() {
      const date = new Date();
      if (date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
        this.value = [`${year}-${month}-${day} 00:00:00`, `${year}-${month}-${day} 23:59:59`];
      }
      return "";
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
